import React from 'react';
import { Loader2 } from 'lucide-react';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  label?: string;
  centered?: boolean;
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  className = '',
  label,
  centered = false,
}) => {
  const sizeClasses = {
    sm: 16,
    md: 24,
    lg: 32,
    xl: 48,
  };

  const spinnerSize = sizeClasses[size];

  const spinner = (
    <div className={`inline-flex flex-col items-center gap-2 ${className}`}>
      <Loader2
        size={spinnerSize}
        className="animate-spin text-primary"
        aria-label={label || 'Chargement en cours'}
      />
      {label && <span className="text-sm text-gray-600">{label}</span>}
    </div>
  );

  if (centered) {
    return (
      <div className="flex items-center justify-center w-full min-h-[200px]">
        {spinner}
      </div>
    );
  }

  return spinner;
};

Spinner.displayName = 'Spinner';

export interface PageSpinnerProps {
  label?: string;
}

export const PageSpinner: React.FC<PageSpinnerProps> = ({ label = 'Chargement...' }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4">
        <Loader2 size={48} className="animate-spin text-primary" />
        <p className="text-lg font-medium text-gray-700">{label}</p>
      </div>
    </div>
  );
};

PageSpinner.displayName = 'PageSpinner';
